
import { useCategoriaProductoStore } from '@/store/erp';
import { usePaymentMethodsStore } from '@/store/erp/system-settings/payment-methods';
import { usePlanStore } from '@/store/erp/system-settings/plan.store';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export type NocModuleProps = {};

const NocModule: React.FC<NocModuleProps> = () => {

  const getpaymentMethodsFilterPaging = usePaymentMethodsStore(s => s.getpaymentMethodsFilterPaging);
  const getPlansCorporativos = usePlanStore(s => s.getPlansCorporativos);
  const getCategoriaProducto = useCategoriaProductoStore(s => s.getCategoriaProducto);
  
  useEffect(() => {
    (async () => {
      const results = await Promise.allSettled([
        getpaymentMethodsFilterPaging({
          page_size: 600
        }),
        getPlansCorporativos({
          page_size:600
        }),
        getCategoriaProducto({ page_size: 600 }),
        ]);
        results.forEach((result, index) => {
          if (result.status === 'rejected') {
            console.error(`Data load failed at position ${index}:`, result.reason);
          }
        });
    })();
  }, []);
  return (
    <Outlet />
  );
};

export default NocModule;
